var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.642822,
    width: 49.7143,
    height: 49.7143,
    rx: 13.8095,
    fill: "#AB54A2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1316_8297)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7241 29.4595H13.2932C12.9143 29.4595 12.6071 29.7659 12.6071 30.144V39.3154C12.6071 39.6934 12.9143 39.9999 13.2932 39.9999H16.7241C17.1031 39.9999 17.4103 39.6934 17.4103 39.3154V30.144C17.4103 29.7659 17.1031 29.4595 16.7241 29.4595Z",
    fill: "#096784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1173 21.1897H19.6864C19.3075 21.1897 19.0002 21.4962 19.0002 21.8742V39.321C19.0002 39.699 19.3075 40.0055 19.6864 40.0055H23.1173C23.4962 40.0055 23.8035 39.699 23.8035 39.321V21.8742C23.8035 21.4962 23.4962 21.1897 23.1173 21.1897Z",
    fill: "#096784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5103 25.0129H26.0795C25.7005 25.0129 25.3933 25.3194 25.3933 25.6975V39.3154C25.3933 39.6934 25.7005 39.9999 26.0795 39.9999H29.5103C29.8893 39.9999 30.1965 39.6934 30.1965 39.3154V25.6975C30.1965 25.3194 29.8893 25.0129 29.5103 25.0129Z",
    fill: "#096784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.909 17.9785H32.4782C32.0992 17.9785 31.792 18.285 31.792 18.663V39.3209C31.792 39.6989 32.0992 40.0054 32.4782 40.0054H35.909C36.288 40.0054 36.5952 39.6989 36.5952 39.3209V18.663C36.5952 18.285 36.288 17.9785 35.909 17.9785Z",
    fill: "#096784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5951 11L31.8644 12.2466L33.0136 13.3986L27.6693 18.6855L21.2985 14.9958L12.6962 22.8092C12.3615 23.1153 12.3392 23.6273 12.6404 23.9612C12.8022 24.1393 13.0254 24.2284 13.2429 24.2284C13.4382 24.2284 13.639 24.156 13.7952 24.0169L21.5105 17.0104L27.9315 20.7279L34.1628 14.5617L35.312 15.7137L36.5951 11Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1316_8297"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.1667,
    height: 29,
    fill: "white",
    transform: "translate(12.4286 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesIcon);
export default __webpack_public_path__ + "static/media/sales-icon.8c4f64705cb06d7546690378089a6b23.svg";
export { ForwardRef as ReactComponent };